/* eslint-disable @typescript-eslint/no-explicit-any */

import { TrackerUserAbstract } from '../@interfaces/Tracker.interface';
import { TTrackProperties } from '../@types/Trackers.types';
import { v4 as uuid } from 'uuid';

let mixpanel: any;

if (typeof window !== 'undefined') {
  mixpanel = require('mixpanel-browser');
}

class Mixpanel {
  static init(): void {
    try {
      const session_id = uuid();
      localStorage.setItem('mixpanel_session_id', session_id);
      mixpanel.init(window.env.MIXPANEL_KEY);
    } catch (e) {
      console.error(e);
    }
  }

  static identify(user?: TrackerUserAbstract): void {
    try {
      mixpanel.identify(user?.id);
      if (user && typeof user === 'object') {
        mixpanel.people.set(user);
      }
    } catch (e) {
      console.error(e);
    }
  }

  static track({ eventName, properties, application }: TTrackProperties): void {
    try {
      const session_id = localStorage.getItem('mixpanel_session_id');
      const user_agent = window?.navigator.userAgent;

      mixpanel.track(eventName, {
        ...properties,
        application,
        session_id,
        user_agent,
      });
    } catch (e) {
      console.error(e);
    }
  }
}

const mixpanelClient = {
  init: (): void => {
    Mixpanel.init();
  },
  identify: (user?: TrackerUserAbstract): void => {
    Mixpanel.identify(user);
  },
  track: ({ eventName, properties, application }: TTrackProperties): void => {
    Mixpanel.track({ eventName, properties, application });
  },
};

export { Mixpanel, mixpanelClient };
